<pr-treatments-search
  [expanded]="true"
  [includeMultiTreatments]="data.includeMultiTreatments"
  (chartableAdded)="addChartable($event)"
 />
